import { useState } from "react";
import './AutoComplete.css';
import { Link } from 'react-router-dom';

const AutoComplete = () => {
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionIndex, setSuggestionIndex] = useState(0);
  const [suggestionsActive, setSuggestionsActive] = useState(false);
  const [value, setValue] = useState("");

  const AutoCompleteData = [
    "Tech Expressway",
    "AI",
    "Automation (RPA)",
    "Cloud",
    "Custom Engineering",
    "EAI",
    "Enterprise Data",
    "Infrastructure Engineering",
    "Innovation and Human Skills",
    "Intelligent Platforms",
    "Interactive",
    "Quality Engineering",
    // "Salesforce",
    "Security",
    // "Tech Leap",
    "Aspirational Learning",
    "Design Thinking",
    "Technology",
    "Agile",
    "Delivery",
    "DevOps",
    "SRE",
    "Inclusion and Diversity",
    "Sustainability",
    "Build Credentials",
    "Demystifying AI",
    "AI Ascend",
    "ML Academy",
    "Python Academy",
    "RPA with BluePrism",
    "RPA with Automation Anywhere",
    "Accenture Reinvention Console",
    "RPA with Uipath",
    "Cloud Elevate",
    "Google SRE Foundation School",
    "RedHat Cloud-Native Development School",
    "Spring Boot Microservice Experts",
    "Spring Fast Track Program",
    "Java Full Stack Blended Program",
    "Java Full Stack Development using Spring and React",
    "Java Spring Boot Microservice Application Developer",
    "Creating Microservice Components Using Spring Boot and Angular11",
    "Java FSE",
    "Mulesoft Expert Program",
    "Databricks",
    "DFA for IE",
    // "FSE - Full Stack Engineer",
    "Multi Skilling Program",
    "Nordea",
    "Atrias",
    "Network Architect",
    "IaC - Infrastructure as a Code",
    "Linux Capability Development",
    "Innoquest",
    "Innovation Bootcamp",
    "Utkarsh",
    "VDCC",
    "InnoSpark",
    "DCCC",
    "Empower Her",
    "EIT Academy",
    "IXO Academy",
    // "SAP Calendar",
    "Fullstack Web Developer School",
    "Build Cross Platform Apps with Flutter",
    "API Testing using SOAP UI",
    "Quality Engineering Automation School - TOSCA",
    "Selenium Advanced for UI Testing Automation",
    "ETL Testing",
    "Testing in DevOps",
    "AI in Testing",
    "Testing in Cloud",
    "Quality Engineering Mobile Automation School",
    "QEEP",
    "SDET",
    "Scriptless test Automation using Tosca",
    "Security Foundation Academy",
    "DLF for Security",
    "Cyberbit",
    "CyberHER",
    "Cyber security essentials for beginners",
    "Delivery Adept Academy",
    "Industry Learning",
    "Learning Labs",
    "SailPoint IIQ training",
    "Accenture Security Internship Program",
    "ASPIRA",
    "Delivery Lead Practitioner School",
    "Delivery Sales Academy",
    "MITO Master Class",
    "SI Foundation class for Delivery Managers",
    "SI Master Class",
    "SI Salesforce",
    "Design Thinking Academy",
    "Driving Client Centric Connects (DCCC)",
    "Value-driven Client Conversation (VDCC)",
    "Cloud Foundation Academy",
    "Data on Cloud Primer",       
    "Quality Engineering Executive Program (QEEP)",
    "SAP TQ for Leaders",    
    "SAFe Transformation Program",
    "Agile Offerings",
    "Agile Azure Board Essentials",
    "Agile Nexus",
    "PSM1 Certification Enablement Course",
    "Delivery Foundation Academy",
    "Omniconnect",
    "Automation Architect Training",
    "Leadership Program",
    "ATCI Technology Core Learning",
    "SI",
    "AO",
    "Project Management",
    "Terraform Certification program",
    "Advanced DevOps Academy",
    "Advanced IAC",
    "CKA Certification Program",
    "DevOps on Cloud",
    "End to End DevOps",
    "SRE Foundation School",
    "SRE Foundation Bootcamp",
    "SRE Practitioner School",
    "SRE Practitioner Bootcamp",
    "Aarambh",
    "Agrani",
    "Accessibility",
    "IID",
    "Cyberher",
    "Her Cloud",
    "HTW Edge",
    "Quantum Impact Program",
    "STEM",
    "Adobe",
    "Amazon Web Services",
    "Automation Anywhere",
    "Coupa",
    "Dassault Systems",
    "Google",
    "HashiCorp",
    "ITIL",
    "Linux Foundation",
    "Microsoft",
    "Mulesoft",
    "Network",
    "Oracle",
    "Pega",
    "PMI",
    "Red Hat",    
    "SAP",
    "SAFe",
    "Scrum",
    "Security",
    "ServicesNow",
    "SnowFlake",
    "Splunk",
    "TOGAF",
    "Tricentis",
    "Workday",
    "Service Management",
    "Workplace"
  ];

  const AutoCompleteDetail = {
    TechExpressway: {
      menu1: "core",
      menu2: "c_tech",
      menu3: "TechExpressway"
    },
    AI: {
      menu1: "pivot",
      menu2: "p_ai"
    },
    AutomationRPA: {
      menu1: "pivot",
      menu2: "p_automation"
    },
    Cloud: {
      menu1: "pivot",
      menu2: "p_cloud"
    },
    CustomEngineering: {
      menu1: "pivot",
      menu2: "p_custom"
    },
    EAI: {
      menu1: "pivot",
      menu2: "p_eai"
    },
    EnterpriseData: {
      menu1: "pivot",
      menu2: "p_enterprice"
    },
    InfrastructureEngineering: {
      menu1: "pivot",
      menu2: "p_infrastructure"
    },
    InnovationandHumanSkills: {
      menu1: "pivot",
      menu2: "p_innovation"
    },
    IntelligentPlatforms: {
      menu1: "pivot",
      menu2: "p_intelligent"
    },
    Interactive: {
      menu1: "pivot",
      menu2: "p_interactive"
    },
    QualityEngineering: {
      menu1: "pivot",
      menu2: "p_quality"
    },
    // Salesforce: {
    //   menu1: "pivot",
    //   menu2: "p_salesforce"
    // },
    Security: {
      menu1: "pivot",
      menu2: "p_security"
    },
    // TechLeap: {
    //   menu1: "pivot",
    //   menu2: "p_tech",
    //   menu3: "TechLeap"
    // },
    AspirationalLearning: {
      menu1: "lead",
      menu2: "l_aspirational"
    },
    DesignThinking: {
      menu1: "lead",
      menu2: "l_design"
    },
    Technology: {
      menu1: "lead",
      menu2: "l_technology"
    },
    Agile: {
      menu1: "deliver",
      menu2: "d_agile"
    },
    Delivery: {
      menu1: "deliver",
      menu2: "d_delivery"
    },
    DevOps: {
      menu1: "deliver",
      menu2: "d_devops"
    },
    SRE: {
      menu1: "deliver",
      menu2: "d_sre"
    },
    InclusionandDiversity: {
      menu1: "force",
      menu2: "f_inclusion"
    },
    Sustainability: {
      menu1: "force",
      menu2: "f_sustain"
    },
    BuildCredentials: {
      menu1: "build",
      menu2: ""
    },
    DemystifyingAI: {
      menu1: "pivot",
      menu2: "p_ai",
      menu3: "DemystifyingAI"
    },
    AIAscend: {
      menu1: "pivot",
      menu2: "p_ai",
      menu3: "AIAscend"
    },
    MLAcademy: {
      menu1: "pivot",
      menu2: "p_ai",
      menu3: "MLAcademy"
    },
    PythonAcademy: {
      menu1: "pivot",
      menu2: "p_ai",
      menu3: "PythonAcademy"
    },
    RPAwithBluePrism: {
      menu1: "pivot",
      menu2: "p_automation",
      menu3: "RPAwithBluePrism"
    },
    RPAwithAutomationAnywhere: {
      menu1: "pivot",
      menu2: "p_automation",
      menu3: "RPAwithAutomationAnywhere"
    },
    AccentureReinventionConsole: {
      menu1: "pivot",
      menu2: "p_architect",
      menu3: "AccentureReinventionConsole"
    },
    RPAwithUipath: {
      menu1: "pivot",
      menu2: "p_automation",
      menu3: "RPAwithUipath"
    },
    CloudElevate: {
      menu1: "pivot",
      menu2: "p_cloud",
      menu3: "CloudElevate"
    },
    GoogleSREFoundationSchool: {
      menu1: "pivot",
      menu2: "p_cloud",
      menu3: "GoogleSREFoundationSchool"
    },
    IXOAcademy: {
      menu1: "pivot",
      menu2: "p_cloud",
      menu3: "IXOAcademy"
    },
    RedHatCloudNativeDevelopmentSchool: {
      menu1: "pivot",
      menu2: "p_cloud",
      menu3: "RedHatCloudNativeDevelopmentSchool"
    },
    SpringBootMicroserviceExperts: {
      menu1: "pivot",
      menu2: "p_custom",
      menu3: "SpringBootMicroserviceExperts"
    },
    SpringFastTrackProgram: {
      menu1: "pivot",
      menu2: "p_custom",
      menu3: "SpringFastTrackProgram"
    },
    JavaFullStackBlendedProgram: {
      menu1: "pivot",
      menu2: "p_custom",
      menu3: "JavaFullStackBlendedProgram"
    },
    JavaFullStackDevelopmentusingSpringandReact: {
      menu1: "pivot",
      menu2: "p_custom",
      menu3: "JavaFullStackDevelopmentusingSpringandReact"
    },
    JavaSpringBootMicroserviceApplicationDeveloper: {
      menu1: "pivot",
      menu2: "p_custom",
      menu3: "JavaSpringBootMicroserviceApplicationDeveloper"
    },
    CreatingMicroserviceComponentsUsingSpringBootandAngular11: {
      menu1: "pivot",
      menu2: "p_custom",
      menu3: "CreatingMicroserviceComponentsUsingSpringBootandAngular11"
    },
    JavaFSE: {
      menu1: "pivot",
      menu2: "p_custom",
      menu3: "JavaFSE"
    },
    MulesoftExpertProgram: {
      menu1: "pivot",
      menu2: "p_eai",
      menu3: "MulesoftExpertProgram"
    },
    Databricks: {
      menu1: "pivot",
      menu2: "p_enterprice",
      menu3: "Databricks"
    },
    DFAforIE: {
      menu1: "pivot",
      menu2: "p_infrastructure",
      menu3: "DFAforIE"
    },
    // FSEFullStackEngineer: {
    //   menu1: "pivot",
    //   menu2: "p_infrastructure",
    //   menu3: "FSEFullStackEngineer"
    // },
    Nordea: {
      menu1: "talent",
      menu2: "t_talent",
      menu3: "Nordea"
    },
    Atrias: {
      menu1: "talent",
      menu2: "t_talent",
      menu3: "Atrias"
    },
    MultiSkillingProgram: {
      menu1: "pivot",
      menu2: "p_infrastructure",
      menu3: "MultiSkillingProgram"
    },
    NetworkArchitect: {
      menu1: "pivot",
      menu2: "p_infrastructure",
      menu3: "NetworkArchitect"
    },
    IaCInfrastructureasaCode: {
      menu1: "pivot",
      menu2: "p_infrastructure",
      menu3: "IaCInfrastructureasaCode"
    },
    LinuxCapabilityDevelopment: {
      menu1: "pivot",
      menu2: "p_infrastructure",
      menu3: "LinuxCapabilityDevelopment"
    },
    Innoquest: {
      menu1: "pivot",
      menu2: "p_innovation",
      menu3: "Innoquest"
    },
    InnovationBootcamp: {
      menu1: "pivot",
      menu2: "p_innovation",
      menu3: "InnovationBootcamp"
    },
    Utkarsh: {
      menu1: "pivot",
      menu2: "p_innovation",
      menu3: "Utkarsh"
    },
    VDCC: {
      menu1: "pivot",
      menu2: "p_innovation",
      menu3: "VDCC"
    },
    InnoSpark: {
      menu1: "pivot",
      menu2: "p_innovation",
      menu3: "InnoSpark"
    },
    DCCC: {
      menu1: "pivot",
      menu2: "p_innovation",
      menu3: "DCCC"
    },
    EmpowerHer: {
      menu1: "pivot",
      menu2: "p_innovation",
      menu3: "EmpowerHer"
    },
    IPSAcademy: {
      menu1: "pivot",
      menu2: "p_intelligent",
      menu3: "IPSAcademy"
    },
    EITAcademy: {
      menu1: "pivot",
      menu2: "p_intelligent",
      menu3: "E&ITAcademy"
    },
    // IXOAcademy: {
    //   menu1: "pivot",
    //   menu2: "p_ixo",
    //   menu3: "IXOAcademy"
    // },
    // SAPCalendar: {
    //   menu1: "pivot",
    //   menu2: "p_intelligent",
    //   menu3: "SAPCalendar"
    // },
    FullstackWebDeveloperSchool: {
      menu1: "pivot",
      menu2: "p_interactive",
      menu3: "FullstackWebDeveloperSchool"
    },
    BuildCrossPlatformAppswithFlutter: {
      menu1: "pivot",
      menu2: "p_interactive",
      menu3: "BuildCrossPlatformAppswithFlutter"
    },
    APITestingusingSOAPUI: {
      menu1: "pivot",
      menu2: "p_quality",
      menu3: "APITestingusingSOAPUI"
    },
    QualityEngineeringAutomationSchoolTOSCA: {
      menu1: "pivot",
      menu2: "p_quality",
      menu3: "QualityEngineeringAutomationSchoolTOSCA"
    },
    SeleniumAdvancedforUITestingAutomation: {
      menu1: "pivot",
      menu2: "p_quality",
      menu3: "SeleniumAdvancedforUITestingAutomation"
    },
    ETLTesting: {
      menu1: "pivot",
      menu2: "p_quality",
      menu3: "ETLTesting"
    },
    TestinginDevOps: {
      menu1: "pivot",
      menu2: "p_quality",
      menu3: "TestinginDevOps"
    },
    AIinTesting: {
      menu1: "pivot",
      menu2: "p_quality",
      menu3: "AIinTesting"
    },
    TestinginCloud: {
      menu1: "pivot",
      menu2: "p_quality",
      menu3: "TestinginCloud"
    },
    QualityEngineeringMobileAutomationSchool: {
      menu1: "pivot",
      menu2: "p_quality",
      menu3: "QualityEngineeringMobileAutomationSchool"
    },
    QEEP: {
      menu1: "pivot",
      menu2: "p_quality",
      menu3: "QEEP"
    },
    SDET: {
      menu1: "pivot",
      menu2: "p_quality",
      menu3: "SDET"
    },
    ScriptlesstestAutomationusingTosca: {
      menu1: "pivot",
      menu2: "p_quality",
      menu3: "ScriptlesstestAutomationusingTosca"
    },
    SecurityFoundationAcademy: {
      menu1: "pivot",
      menu2: "p_security",
      menu3: "SecurityFoundationAcademy"
    },
    DLFforSecurity: {
      menu1: "pivot",
      menu2: "p_security",
      menu3: "DLFforSecurity"
    },
    Cyberbit: {
      menu1: "pivot",
      menu2: "p_security",
      menu3: "Cyberbit"
    },
    CyberHER: {
      menu1: "pivot",
      menu2: "p_security",
      menu3: "CyberHER"
    },
    Cybersecurityessentialsforbeginners: {
      menu1: "pivot",
      menu2: "p_security",
      menu3: "Cybersecurityessentialsforbeginners"
    },
    DeliveryAdeptAcademy: {
      menu1: "pivot",
      menu2: "p_security",
      menu3: "DeliveryAdeptAcademy"
    },
    IndustryLearning: {
      menu1: "pivot",
      menu2: "p_security",
      menu3: "IndustryLearning"
    },
    LearningLabs: {
      menu1: "pivot",
      menu2: "p_security",
      menu3: "LearningLabs"
    },
    SailPointIIQtraining: {
      menu1: "pivot",
      menu2: "p_security",
      menu3: "SailPointIIQtraining"
    },
    AccentureSecurityInternshipProgram: {
      menu1: "pivot",
      menu2: "p_security",
      menu3: "AccentureSecurityInternshipProgram"
    },    
    ASPIRA: {
      menu1: "lead",
      menu2: "l_aspirational",
      menu3: "ASPIRA"
    },
    DeliveryLeadPractitionerSchool: {
      menu1: "lead",
      menu2: "l_design",
      menu3: "DeliveryLeadPractitionerSchool"
    },
    DeliverySalesAcademy: {
      menu1: "lead",
      menu2: "l_design",
      menu3: "DeliverySalesAcademy"
    },
    MITOMasterClass: {
      menu1: "lead",
      menu2: "l_design",
      menu3: "MITOMasterClass"
    },
    SIFoundationclassforDeliveryManagers: {
      menu1: "lead",
      menu2: "l_design",
      menu3: "SIFoundationclassforDeliveryManagers"
    },    
    SIMasterClass: {
      menu1: "lead",
      menu2: "l_design",
      menu3: "SIMasterClass"
    },
    SISalesforce: {
      menu1: "lead",
      menu2: "l_design",
      menu3: "SISalesforce"
    },
    DesignThinkingAcademy: {
      menu1: "lead",
      menu2: "l_human",
      menu3: "DesignThinkingAcademy"
    },
    DrivingClientCentricConnectsDCCC: {
      menu1: "lead",
      menu2: "l_human",
      menu3: "DrivingClientCentricConnectsDCCC"
    },
    ValuedrivenClientConversationVDCC: {
      menu1: "lead",
      menu2: "l_human",
      menu3: "ValuedrivenClientConversationVDCC"
    },
    CloudFoundationAcademy: {
      menu1: "lead",
      menu2: "l_technology",
      menu3: "CloudFoundationAcademy"
    },    
    DataonCloudPrimer: {
      menu1: "lead",
      menu2: "l_technology",
      menu3: "DataonCloudPrimer"
    },        
    QualityEngineeringExecutiveProgramQEEP: {
      menu1: "lead",
      menu2: "l_technology",
      menu3: "QualityEngineeringExecutiveProgramQEEP"
    },
    SAPTQforLeaders: {
      menu1: "lead",
      menu2: "l_technology",
      menu3: "SAPTQforLeaders"
    },                                                            
    SAFeTransformationProgram: {
      menu1: "deliver",
      menu2: "d_agile",
      menu3: "SAFeTransformationProgram"
    },
    AgileOfferings: {
      menu1: "deliver",
      menu2: "d_agile",
      menu3: "AgileOfferings"
    },
    AgileAzureBoardEssentials: {
      menu1: "deliver",
      menu2: "d_agile",
      menu3: "AgileAzureBoardEssentials"
    },
    AgileNexus: {
      menu1: "deliver",
      menu2: "d_agile",
      menu3: "AgileNexus"
    },
    PSM1CertificationEnablementCourse: {
      menu1: "deliver",
      menu2: "d_agile",
      menu3: "PSM1CertificationEnablementCourse"
    },
    DeliveryFoundationAcademy: {
      menu1: "deliver",
      menu2: "d_delivery",
      menu3: "DeliveryFoundationAcademy"
    },
    Omniconnect: {
      menu1: "deliver",
      menu2: "d_delivery",
      menu3: "Omniconnect"
    },
    AutomationArchitectTraining: {
      menu1: "deliver",
      menu2: "d_delivery",
      menu3: "AutomationArchitectTraining"
    },
    LeadershipProgram: {
      menu1: "deliver",
      menu2: "d_delivery",
      menu3: "LeadershipProgram"
    },
    ATCITechnologyCoreLearning: {
      menu1: "deliver",
      menu2: "d_delivery",
      menu3: "ATCITechnologyCoreLearning"
    },
    SI: {
      menu1: "deliver",
      menu2: "d_delivery",
      menu3: "SI"
    },
    AO: {
      menu1: "deliver",
      menu2: "d_delivery",
      menu3: "AO"
    },
    ProjectManagement: {
      menu1: "deliver",
      menu2: "d_delivery",
      menu3: "ProjectManagement"
    },
    TerraformCertificationprogram: {
      menu1: "deliver",
      menu2: "d_devops",
      menu3: "TerraformCertificationprogram"
    },
    AdvancedDevOpsAcademy: {
      menu1: "deliver",
      menu2: "d_devops",
      menu3: "AdvancedDevOpsAcademy"
    },
    AdvancedIAC: {
      menu1: "deliver",
      menu2: "d_devops",
      menu3: "AdvancedIAC"
    },
    CKACertificationProgram: {
      menu1: "deliver",
      menu2: "d_devops",
      menu3: "CKACertificationProgram"
    },
    DevOpsonCloud: {
      menu1: "deliver",
      menu2: "d_devops",
      menu3: "DevOpsonCloud"
    },
    EndtoEndDevOps: {
      menu1: "deliver",
      menu2: "d_devops",
      menu3: "EndtoEndDevOps"
    },
    SREFoundationSchool: {
      menu1: "deliver",
      menu2: "d_sre",
      menu3: "SREFoundationSchool"
    },
    SREFoundationBootcamp: {
      menu1: "deliver",
      menu2: "d_sre",
      menu3: "SREFoundationBootcamp"
    },
    SREPractitionerSchool: {
      menu1: "deliver",
      menu2: "d_sre",
      menu3: "SREPractitionerSchool"
    },
    SREPractitionerBootcamp: {
      menu1: "deliver",
      menu2: "d_sre",
      menu3: "SREPractitionerBootcamp"
    },
    Aarambh: {
      menu1: "force",
      menu2: "f_inclusion",
      menu3: "Aarambh"
    },
    Agrani: {
      menu1: "force",
      menu2: "f_inclusion",
      menu3: "Agrani"
    },
    Accessibility: {
      menu1: "force",
      menu2: "f_inclusion",
      menu3: "Accessibility"
    },
    IID: {
      menu1: "force",
      menu2: "f_inclusion",
      menu3: "IID"
    },
    Cyberher: {
      menu1: "force",
      menu2: "f_inclusion",
      menu3: "Cyberher"
    },
    HerCloud: {
      menu1: "force",
      menu2: "f_inclusion",
      menu3: "HerCloud"
    },
    HTWEdge: {
      menu1: "force",
      menu2: "f_inclusion",
      menu3: "HTWEdge"
    },
    QuantumImpactProgram: {
      menu1: "force",
      menu2: "f_inclusion",
      menu3: "QuantumImpactProgram"
    },
    STEM: {
      menu1: "force",
      menu2: "f_inclusion",
      menu3: "STEM"
    },
    Adobe: {
      menu1: "build",
      menu2: "",
      menu3: "Adobe"
    },
    AmazonWebServices: {
      menu1: "build",
      menu2: "",
      menu3: "AmazonWebServices"
    },
    AutomationAnywhere: {
      menu1: "build",
      menu2: "",
      menu3: "AutomationAnywhere"
    },
    Coupa: {
      menu1: "build",
      menu2: "",
      menu3: "Coupa"
    },
    DassaultSystems: {
      menu1: "build",
      menu2: "",
      menu3: "DassaultSystems"
    },
    Google: {
      menu1: "build",
      menu2: "",
      menu3: "Google"
    },
    HashiCorp: {
      menu1: "build",
      menu2: "",
      menu3: "HashiCorp"
    },
    ITIL: {
      menu1: "build",
      menu2: "",
      menu3: "ITIL"
    },
    LinuxFoundation: {
      menu1: "build",
      menu2: "",
      menu3: "LinuxFoundation"
    },
    Microsoft: {
      menu1: "build",
      menu2: "",
      menu3: "Microsoft"
    },
    Mulesoft: {
      menu1: "build",
      menu2: "",
      menu3: "Mulesoft"
    },
    Network: {
      menu1: "build",
      menu2: "",
      menu3: "Network"
    },
    Oracle: {
      menu1: "build",
      menu2: "",
      menu3: "Oracle"
    },
    Pega: {
      menu1: "build",
      menu2: "",
      menu3: "Pega"
    },
    PMI: {
      menu1: "build",
      menu2: "",
      menu3: "PMI"
    },
    RedHat: {
      menu1: "build",
      menu2: "",
      menu3: "RedHat"
    },
    SAP: {
      menu1: "build",
      menu2: "",
      menu3: "SAP"
    },
    SAFe: {
      menu1: "build",
      menu2: "",
      menu3: "SAFe"
    },
    Scrum: {
      menu1: "build",
      menu2: "",
      menu3: "Scrum"
    },
    ServicesNow: {
      menu1: "build",
      menu2: "",
      menu3: "ServicesNow"
    },
    SnowFlake: {
      menu1: "build",
      menu2: "",
      menu3: "SnowFlake"
    },
    Splunk: {
      menu1: "build",
      menu2: "",
      menu3: "Splunk"
    },
    TOGAF: {
      menu1: "build",
      menu2: "",
      menu3: "TOGAF"
    },
    Tricentis: {
      menu1: "build",
      menu2: "",
      menu3: "Tricentis"
    },
    Workday: {
      menu1: "build",
      menu2: "",
      menu3: "Workday"
    },
    ServiceManagement: {
      menu1: "build",
      menu2: "",
      menu3: "ServiceManagement"
    },
    Workplace: {
      menu1: "build",
      menu2: "",
      menu3: "Workplace"
    }
  }


  const handleChange = (e) => {
    const query = e.target.value.toLowerCase();
    setValue(query);
    if (query.length > 0) {
      const filterSuggestions = AutoCompleteData.filter(
        (suggestion) => {
          return suggestion.toLowerCase().indexOf(query) > -1
        }
      );
      setSuggestions(filterSuggestions);
      setSuggestionsActive(true);
    } else {
      setSuggestionsActive(false);
    }
  };

  const handleClick = (e) => {
    setSuggestions([]);
    setValue(e.target.innerText);
    setSuggestionsActive(false);
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 38) {
      if (suggestionIndex === 0) {
        return;
      }
      setSuggestionIndex(suggestionIndex - 1);
    }
    else if (e.keyCode === 40) {
      if (suggestionIndex - 1 === suggestions.length) {
        return;
      }
      setSuggestionIndex(suggestionIndex + 1);
    }
    else if (e.keyCode === 13) {
      setValue(suggestions[suggestionIndex]);
      setSuggestionIndex(0);
      setSuggestionsActive(false);
    }
  };

  const filterString = (string) => {
    return string.replace(/[ ()-]/g, "");
  }

  const Suggestions = () => {
    return (
      <ul className="suggestions">        
        {suggestions.length === 0 ?  (<li className="suggestions-link"><Link className="suggest-no-match-link">No Results Found</Link></li>) : suggestions.map((suggestion, index) => {
          // let text = suggestion.toLowerCase();
          // let idx = text.indexOf(value);
          // let newText = [suggestion.substring(0, idx), <strong>{suggestion.substring(idx, idx + value.length)}</strong>, suggestion.substring(idx + value.length)];
          return (
            <li className={index === suggestionIndex ? "lkm_search_list suggestions-link" : "lkm_search_list suggestions-link"} key={index} onClick={handleClick}>
              <Link className="suggest-link" to={{ pathname: '/offerings', menu1: AutoCompleteDetail[filterString(suggestion)].menu1, menu2: AutoCompleteDetail[filterString(suggestion)].menu2, menu3: AutoCompleteDetail[filterString(suggestion)].menu3 }}>{suggestion}</Link>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div className="autocomplete">
      <input type="text" value={value} onChange={handleChange} onKeyDown={handleKeyDown} placeholder="Search Offerings..." class="search-icon" aria-label="Search Offerings..." />
      {value && <Link to={{ pathname: '/offerings'}}><img src="images/Home/close_icon.png" alt="clear img" className="clear-icon" onClick={()=>{setValue('');setSuggestions([]);setSuggestionsActive(false);}}/></Link>}
      {suggestionsActive && <div className="ac-suggetions">
        <Suggestions />
      </div>}
    </div>
  );
};

export default AutoComplete;